<div class="vehicle-details">
  <div class="vehicle-details__header">
    <div class="vehicle-details__wrapper">
      <div
        class="vehicle-details__header__info"
        [class.vehicle-details__header__info--lock]="isBlocked">
        <vdo-icon svgIcon="vehicle-on" />
        <span class="plate">{{ data()?.plate ?? 'n/D' }}</span>
      </div>

      @if (isBlocked) {
        <vdo-icon svgIcon="lock" />
      }
    </div>

    <div class="vehicle-details__actions">
      <button
        vdo-btn-stroked-mini
        title="{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.ACTIONS.ZOOM' | translate }}"
        (click)="executeEvent.emit('zoom')">
        <vdo-icon svgIcon="my-location" />
      </button>
      <button
        vdo-btn-stroked-mini
        title="{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.ACTIONS.FOLLOW_UP' | translate }}"
        (click)="executeEvent.emit('follow-up')">
        <vdo-icon svgIcon="near-me" />
      </button>
      <button
        vdo-btn-stroked-mini
        title="{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.ACTIONS.GOOGLE_MAPS' | translate }}"
        (click)="executeEvent.emit('go-to-google-maps')">
        <vdo-icon svgIcon="travel-explore" />
      </button>
      <a
        vdo-btn-stroked-mini
        (click)="navigateToReferencePoint()"
        title="{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.ACTIONS.REFERENCE_POINT' | translate }}">
        <vdo-icon svgIcon="add-location-alt" />
      </a>
      <a
        vdo-btn-stroked-mini
        (click)="navigateToLastRecords()"
        title="{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.ACTIONS.LAST_RECORDS' | translate }}">
        <vdo-icon svgIcon="format-list-bulleted" />
      </a>
    </div>
  </div>

  <div class="vehicle-details__content">
    <p>
      <strong>{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.CONTACT' | translate }}:</strong>
      {{ data()?.phoneNumber ?? 'N/A' }}
    </p>
    <p>
      <strong>{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.DRIVER_NAME' | translate }} :</strong>
      {{ data()?.driverName ?? 'N/A' }}
    </p>
    <p>
      <strong>{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.UPDATE_AT' | translate }}:</strong>
      {{ (data()?.eventDate | date:'dd/MM/yyyy HH:mm:ss') ?? 'N/A' }}
    </p>
    <p>
      <strong>{{ 'UI.COMPONENTS.MAP_MAKER_DETAILS.VELOCITY' | translate }}:</strong>
      {{ data()?.speed ?? '0' }} (GPS)
    </p>
  </div>
</div>
